import { IconTheme } from './theme.types'

export const icons: IconTheme = {}
